import { API_KEY_TYPES } from "models";
import { useKeysFilterUpdate } from "modules/ApiKeys/hooks/useApiKeysFilters";

export const useApiKeysFilterHandlers = () => {
  const keysFiltersUpdate = useKeysFilterUpdate();

  const handleSearchTermChange = (term: string) => keysFiltersUpdate({ term });
  const handleTypeChange = (api_key_type: API_KEY_TYPES | null) => keysFiltersUpdate({ api_key_type });

  return { handleSearchTermChange, handleTypeChange };
};
